<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
// import './qiankun'

export default {
  data() {
    return {}
  },
  computed: {
    locale() {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    },
  },
}
</script>
<style  lang="less">
.ant-layout-footer {
  display: none;
}
.distpicker-address-wrapper select {
  height: 37px !important;
  width: 140px !important;
  padding: 0 !important;
  font-size: 14px !important;
  border-radius: 6px !important;
}
.ant-pro-page-header-wrap-page-header-warp {
  display: none !important;
}
// .ant-page-header.has-breadcrumb {
//   display: none !important;
// }
// .ant-menu-item,
// .ant-menu-submenu .ant-menu-submenu-inline {
//   font-size: 18px !important;
//   i {
//     font-size: 18px !important;
//   }
// }
// .ant-menu-submenu-title {
//   font-size: 18px !important;
//   i {
//     font-size: 18px !important;
//   }
// }
// .ant-form-item-required,
// .ant-form label {
//   font-size: 20px !important;
// }
// .ant-divider-inner-text {
//   font-size: 20px !important;
// }
// .ant-input {
//   font-size: 19px !important;
//   min-height: 40px !important;
//   // font-size: 20px !important;
// }
// .ant-select-selection,
// .ant-select-selection__rendered {
//   height: 40px !important;
//   font-size: 19px !important;
// }
// .ant-select-selection-selected-value {
//   line-height: 40px !important;
// }
// .ant-table-column-title {
//   font-size: 18px;
// }
// .ant-table-selection-column {
//   td {
//     font-size: 26px !important;
//   }
// }
// html {
//   font-size: 86px; /* 或者根据需要设置更大的值 */
// }
/deep/.ant-layout-content .ant-pro-basicLayout-content {
  height: 150vh !important;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  &:first-child {
    // background: red !important;
    width: 10px !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
.ant-table-selection-column {
  width: 50px; /* 调整为你想要的宽度 */
}
.ant-table-selection-column .ant-table-selection-select-all-checkbox {
  width: 20px !important; /* 可以单独缩小全选框的宽度 */
}
body, html {
  touch-action: manipulation !important;
}
.movable-view {
  touch-action: none !important; /* 允许自定义拖拽 */
}
iframe {
  pointer-events: auto !important; /* 确保事件能穿透 */
}
// .ant-notification {
//   top: 50% !important;
//   left: 50% !important;
//   transform: translateY(-50%) !important;
//   width: auto !important;
//   // max-width: 30%;
// }

// .ant-notification-notice {
//  width: 40%;
//   text-align: center;
// }
// .ant-table-row-cell-break-word{
//   padding: 0 !important;
//     padding-top: 5px !important;
//   padding-left: 5px !important;
//   padding-right: 5px !important;
//   padding-bottom: 5px !important;
//   td{
//   padding: 0 !important;

//   }
// }
 .ant-table-tbody > tr > td {
  padding: 0 !important;
  padding-top: 8px !important;
  padding-left: 3px !important;
  padding-right: 3px !important;
  padding-bottom: 8px !important;
 }
 .ant-menu-sub{
  .ant-menu-item{
    padding-left: 35px !important;
  //          word-wrap: break-word; /* 兼容旧浏览器，允许在单词内换行 */
  // word-break: break-all; /* 强制换行，支持所有字符（包括英文/数字） */
  // white-space: normal; /* 恢复默认换行（取消可能的强制不换行） */
    span{

    }
  }
 }
 .ant-layout{
  display: flex;
  // background: red !important;
 }
//  .ant-pro-sider-menu-sider{
//   width: 13% !important;
//   min-width: 13% !important;
//   max-width: 13% !important;
//  }
//  .sidemenu,.ant-pro-fixed-header{
//   padding-left: 14% !important;
//   //  width: 10% !important;
//   //  flex: 1 !important;
//   // background: red !important;
//  }
//  .ant-pro-fixed-header{
//   width: 100% !important;
//  }
</style>
